import { FulfillmentStatus } from "@lib/ShiOneClient";

export function toFulfillmentStatus(
  value?: string | null,
): FulfillmentStatus {
  const normalized = (value ?? "").replace(/\s+/g, "").toLowerCase();

  // Single/double-letter cases are raw Private.WebOrderState codes.
  switch (normalized) {
    case "p":
    case "approvalpending":
    case "pending":
    case "awaitingapproval":
      return FulfillmentStatus.AwaitingApproval;
    case "a":
    case "approved":
    case "orderplaced":
      return FulfillmentStatus.OrderPlaced;
    case "processing":
      return FulfillmentStatus.Processing;
    case "partiallyshipped":
      return FulfillmentStatus.PartiallyShipped;
    case "shipped":
      return FulfillmentStatus.Shipped;
    case "delivered":
      return FulfillmentStatus.Delivered;
    case "et":
    case "transferapprover":
      return FulfillmentStatus.TransferApprover;
    case "rd":
    case "denied":
      return FulfillmentStatus.Denied;
    case "e":
    case "approvalexpired":
      return FulfillmentStatus.ApprovalExpired;
    case "porequested":
      return FulfillmentStatus.PoRequested;
    case "pendingreturn":
      return FulfillmentStatus.PendingReturn;
    case "return":
    case "returned":
      return FulfillmentStatus.Returned;
    case "c":
    case "cancelled":
    case "canceled":
      return FulfillmentStatus.Cancelled;
    default:
      return FulfillmentStatus.NotApplicable;
  }
}
